import React, { createContext, useContext, useState, useEffect } from 'react';

const AccessibilityContext = createContext(null);

const SCALE_TO_FONT = { normal: '100%', large: '112.5%', xlarge: '125%' };
const STORAGE_KEY = 'trainedbyrs_text_scale';

export function AccessibilityProvider({ children }) {
  const [textScale, setTextScaleState] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return SCALE_TO_FONT[saved] ? saved : 'normal';
  });

  useEffect(() => {
    document.documentElement.style.fontSize = SCALE_TO_FONT[textScale] || '100%';
    localStorage.setItem(STORAGE_KEY, textScale);
  }, [textScale]);

  const setTextScale = (scale) => {
    if (SCALE_TO_FONT[scale]) setTextScaleState(scale);
  };

  return (
    <AccessibilityContext.Provider value={{ textScale, setTextScale }}>
      {children}
    </AccessibilityContext.Provider>
  );
}

export function useAccessibility() {
  const ctx = useContext(AccessibilityContext);
  if (!ctx) return { textScale: 'normal', setTextScale: () => {} };
  return ctx;
}
